export default __webpack_public_path__ + "static/media/robotfriends.d38c86d2.png";